export enum TransactionFeeCardType {
  CreditCard = 'CREDIT_CARD',
  DebitCard = 'DEBIT_CARD',
  CommercialCreditCard = 'COMMERCIAL_CREDIT_CARD',
  CreditCardNonEEA = 'NON_EEA_CARD',
}
